import { render, staticRenderFns } from "./lejuListDp.vue?vue&type=template&id=e3b24b88&scoped=true&"
import script from "./lejuListDp.vue?vue&type=script&lang=js&"
export * from "./lejuListDp.vue?vue&type=script&lang=js&"
import style0 from "./lejuListDp.vue?vue&type=style&index=0&id=e3b24b88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b24b88",
  null
  
)

export default component.exports